const $sliderIntro = $('.slider-intro .js-slider').each(function(index, slider) {
  const $slider = $(slider);

  $slider.slick({
    fade: true,
    dots: true,
    arrows: true,
    prevArrow: $slider.parent().find('.slider__prev'),
    nextArrow: $slider.parent().find('.slider__next'),
    draggable: false
  });
});
